const hviQuestions = [
    {
        title: 'Upplever du din vardag meningsfull?',
        type: 'numbers',
        hints: [
            '1 = vid ett fåtal tillfällen under en vecka',
            '6 = varje dag finns meningsfulla stunder'
        ],
    },
    {
        title: 'Upplever du dig ha kontroll över stressen i din vardag?',
        type: 'numbers',
        hints: [
            '1 = jag upplever stress nästan alla dagar i veckan',
            '6 = jag upplever stress enstaka situationer under en vecka'
        ],
    },
    {
        title: 'Anser du dig få tillräckligt med vila/återhämtning?',
        type: 'numbers',
        hints: [
            '1 = oftast inte',
            '6 = för det mesta'
        ],
    },
    {
        title: 'Anser du dig få den sömn (omfattning och kvalitet) du behöver?',
        type: 'numbers',
        hints: [
            '1 = oftast inte',
            '6 = för det mesta'
        ],
    },
    {
        title: 'Hur är balansen mellan krav och resurser på jobbet?',
        type: 'numbers',
        hints: [
            '1 = förväntningarna från andra och mig själv är för höga och jag mäktar inte med',
            '6 = jag trivs med förväntningarna (andras och egna) och klarar av dom själv eller med tillgängligt stöd'
        ],
    },
    {
        title: 'Hur är balansen mellan krav och resurser hemma?',
        type: 'numbers',
        hints: [
            '1 = förväntningarna från andra och mig själv är för höga och jag mäktar inte med',
            '6 = jag trivs med förväntningarna (andras och egna) och klarar av dom själv eller med tillgängligt stöd'
        ],
    },
    {
        title: 'Hur är din ork när du är på jobbet?',
        type: 'numbers',
        hints: [
            '1 = de flesta dagar har jag bristande ork',
            '6 = min ork räcker till de flesta dagar'
        ],
    },
    {
        title: 'Hur är din ork när du är hemma?',
        type: 'numbers',
        hints: [
            '1 = de flesta dagar har jag bristande ork',
            '6 = min ork räcker till de flesta dagar'
        ],
    },
    {
        title: 'Är du nöjd med din arbetsinsats?',
        type: 'numbers',
        hints: [
            '1 = jag är ofta missnöjd, tänker att det jag gör inte räcker till',
            '6 = jag är för det mesta nöjd, tänker att det jag gör räcker till'
        ],
    },
    {
        title: 'Är du nöjd med din fritid?',
        type: 'numbers',
        hints: [
            '1 = jag är ofta missnöjd, tänker att det jag gör inte räcker till',
            '6 = jag är för det mesta nöjd, tänker att det jag gör räcker till'
        ],
    },
    {
        title: 'Jag kan koppla bort jobbet när jag är ledig',
        type: 'numbers',
        hints: [
            '1 = oftast inte',
            '6 = för det mesta'
        ],
    },
    {
        title: 'Jag kan koppla bort privata frågor när jag är på jobbet',
        type: 'numbers',
        hints: [
            '1 = oftast inte',
            '6 = för det mesta'
        ],
    },
    
];

export default hviQuestions;